<template>
  <div class="details_form_item">
    <Form :model="dataModel" :label-width="100">
      <FormItem label="邮件标题：">{{dataModel.emailTitle}}</FormItem>
      <FormItem label="接受者：">{{dataModel.emailRecive}}</FormItem>
      <FormItem label="抄送者：">{{dataModel.emailCopy}}</FormItem>
      <FormItem label="邮件内容：">{{dataModel.emailContent}}</FormItem>
      <FormItem label="附件：">{{dataModel.emailFiles}}</FormItem>
      <FormItem
        label="发送状态："
      >{{$common.getEnumDescription("EmailSendFlag", dataModel.emailSendFlag)}}</FormItem>
      <FormItem label="发送结果：">{{dataModel.emailSendResult}}</FormItem>
      <FormItem label="发送时间：">{{dataModel.emailSendDate}}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  components: {},
  data: function () {
    return {
      dataModel: {},
    };
  },

  mounted () {
    this.dataModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>